export class VinInfo {
  barcode: string = null;
  vin_number: string = null;
  plate_number: string = null;
  odo: string = null;

  location: string = null;
  city: string = null;
  area: string = null;

  vin_img: string = null;
  plate_img: string = null;
  est_img: string = null;
  mvpi_img: string = null;

  est_exp_date: string = null;
  mvpi_exp_date: string = null;
}

export class Information {
  vin_number: string = null;
  plate_number: string = null;

  estimara_expiry_date: string = null;
  mvpi_expiry_date: string = null;
  warranty_expiry_date: string = null;
  last_service_date: string = null;

  assessment_type_id: string = null;
  make_id: string = null;
  engine_type_id: string = null;
  vendor_id: string = null;
  model_id: string = null;
  engine_cc_id: string = null;
  estimara_id: string = null;
  trim_id: string = null;
  cyllinder_id: string = null;
  vehicle_type_id: string = null;
  transmission_type_id: string = null;
  body_type_id: string = null;
  wheel_base_id: string = null;
  drive_type_id: string = null;
  warranty_id: string = null;
  model_year: string = null;
  exterior_color_id: string = null;
  gear_id: string = null;
  odo: string = null;
  interior_color_id: string = null;
  utility_type_id: string = null;
  door_type_id: string = null;
  seat_id: string = null;
  last_service_km: string = null;
  vehicle_condition_id: string = null;
  fuel_type_id: string = null;
  uphoistery_id: string = null;
  power_id: string = null;
  torque_id: string = null;
  acceleration_id: string = null;
  cod_id: string = null;
  vehicle_location: string = null;
  service_maintainance: string = null;
  max_speed: string = null;
  origin: string = null;
  mileage: string = null;
  mortgage: string = null;
  ownership: string = null;
  market_acceptabilitie_id: string = null;
  country: string = null;
  state: string = null;
  city: string = null;
}
